/**
 * @package   ScandiPWA\GtmGraphQl
 * @author    Abdelrahman Hady <abdelrahman.hady@scandiweb.com>
 * @copyright Copyright (c) 2023 Scandiweb, Inc (https://scandiweb.com)
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 */

import Event, { EVENT_GTM_SELECT_PROMOTION_GA4 } from '../../../util/Event';
// eslint-disable-next-line import/no-cycle
import ViewPromotionEvent from './ViewPromotion.event';

/**
 * @namespace ScandiPWA/GtmGraphQl/Component/GoogleTagManager/GA4_events/Event
 */
export class SelectPromotionEvent extends ViewPromotionEvent {
    eventHandleDelay = 0;

    /**
     * Bind
     */
    bindEvent() {
        Event.observer(EVENT_GTM_SELECT_PROMOTION_GA4, (data) => {
            this.handle(data);
        });
    }
}

export default SelectPromotionEvent;
